import { makeAutoObservable } from 'mobx';

export interface IUiStore {
  showModalAccountRequired: boolean;
}

export class UiStore implements IUiStore {
  showModalAccountRequired = false;

  constructor() {
    makeAutoObservable(this);
  }
}

export const UiStoreDefault: IUiStore = {
  showModalAccountRequired: false
};
